import * as React from 'react';
import { useSelector } from 'react-redux';
import { getNewBuildingApartments } from '../../selectors';
import { ApartmentsList as ApartmentsListComponent } from '../../components/ApartmentsList';
import { IApplicationState } from '../../types/redux';

interface IRoomsListProps {
  newBuildingId: number;
}

export function ApartmentsList({ newBuildingId }: IRoomsListProps) {
  const apartments = useSelector((state: IApplicationState) => getNewBuildingApartments(state, newBuildingId));

  return <ApartmentsListComponent apartments={apartments} />;
}
